<template>
  <div id="ultra-frame" :style="`background-color:${bg}`">
    <div id="ultra-container">
      <!-- NOTE: WorkPackageSubPageModule does not work at all in dummy page -->
      <WorkPackageSubPageModule
        :workpackage="issue.parent"
        :isMobile="false/*isMobile*/"
        :location="location"
        :loading="false/*loading*/"
        :background_color="bg"
        :foreground_color="fg"
        header_icon="mdi-steering"
        :header_text_short="'AUTOPILOTS'/*$t('WorkpackageRework.Info.Log.Header')*/"
        :header_text_long="'AUTOPILOTS & ISSUES'/*$t('WorkpackageRework.Info.Log.Header').toUpperCase() + '.' + $t('WorkpackageRework.Info.Log.List')*/"
        @headerBack="$router.push({name: `${location}WorkPackageInfo`})"
      >
        <template #body>
          <!-- TODO: put div with for loop here -->
        </template>
      </WorkPackageSubPageModule>

      <div style="display: flex; flex-direction: row; grid-gap: 8px; align-items: flex-start;">
        <v-icon :color="fg" large>
          {{ getIssuesIcon(issue) }}
        </v-icon>
        <div style="display: flex; flex-direction: column;">
          <TText
            :text="`${issue.autopilot.function}`"
            :color="fg"
            font_weight="400"
            align="left"
            large
          />
          <TText
            :text="`ISSUE.id: ${issue.uuid}`"
            :color="fg"
            align="left"
            small
          />
          <div style="display: flex; flex-direction: row; grid-gap: 4px;">
            <TText
              :text="`ISSUE.status:`"
              :color="fg"
              small
            />
            <TText
              :text="`${issue.status}`"
              :color="fg"
              font_weight="500"
              small
            />
          </div>
        </div>
      </div>
      <div :style="`width: 100%; margin: 8px 0; border-top: 1px solid ${fg};`"/>
      <TText
        :text="issue.text"
        :color="fg"
        align="left"
      />
      <div style="display: flex; justify-content: end">
        <ButtonOutlined
          style="margin-top: 16px;"
          :text="'Overrule'"
          :color="fg"
        />
      </div>
    </div>
  </div>
</template>

<script>
import WorkPackageSubPageModule from '@/modules/WorkPackageWIP/WorkPackageSubPageModule.module.vue';
import TText from '@/components/Taktify/TText.component.vue';
import ButtonOutlined from '@/components/WorkPackageWIP/ButtonOutlined.component.vue';

import { WorkPackageReworkMixin } from '@/mixins/WorkPackageRework.mixin.js';

  export default {
    components: {
      WorkPackageSubPageModule,
      TText,
      ButtonOutlined,
    },

    props: [
      'location',
    ],

    mixins: [
      WorkPackageReworkMixin,
    ],

    data: () => ({
      bg: '#FFC900',
      fg: '#000',
      // bg: '#330011',
      // fg: '#FFF',

      is_edit: true,

      type: 'work',
      issue: {
          id: 6,
          uuid: "6218e859ca7e6",
          status: "open",
          parent_type: "twork_package",
          parent:
            {
              id: 154745,
              name: "Blechner 2",
              token: "BL2",
              icon: "obj-package-4",
              color: "pink lighten-1",
              status: "done",
              stop_status: "none",
              textcolor: "black",
              taktarea_name:  "A",
              project_id: 72,
              train_id: 1158,
              taktarea_id: 8610,
              twaggon_id: 138577
            },
          text: "@Blechner 2 has been set to \"done\" when not all WORK.steps have been marked as \"done\".",
          autopilot:
            {
              id: 1,
              type: "workpackage",
              trigger: "user",
              trigger_interval: "none",
              function: "WorkPackageStatus",
              description: "description",
              level: 1,
              created: "2020-01-01 00:00:00 UTC",
              updated: "2020-01-01 00:00:00 UTC"},
              logentries: [
                {
                  id: 1254561,
                  action: "created",
                  target: "AUTOPILOT.issue",
                  user: "TAKT.ai",
                  value: "Issue 6218e859ca7e6 has been created. Blechner 2 has been set to \"done\" when not all WORK.steps have been marked as \"done\"",
                  old_value: "",
                  created: "2022-02-25 14:31:53 UTC",
                  updated: "2022-02-25 14:31:53 UTC",
                  crossed_out: false
                }
            ]
        },
    }),

    methods: {
      test() {
        console.log("test ok");
      },

      getIssuesIcon(issue) {
        switch (issue.status) {
          case 'resolved':
            return 'mdi-lock-outline';
          case 'overruled':
            return 'mdi-lock-alert-outline';
          case 'open':
            return 'mdi-lock-open-variant-outline';
          default:
            return 'mdi-alert-circle-outline';
        }
      },
    },
  }
</script>

<style>
  #ultra-frame {
    width: 100%;
    height: calc(100% - 48px) !important;
  }
  #ultra-container {
    margin: 10px;
    margin-top: 0;
  }
</style>
